"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { Stack } from "@mui/system";
import { Typography } from "@mui/material";
import { ColletteButton } from "@collette-travel/collette-common-controls";

const NotFound = () => {
  const t = useTranslations("NOT_FOUND");
  return (
    <Stack
      gap="3.3rem"
      paddingLeft="5rem"
      paddingRight="5rem"
      margin="2rem"
      textAlign="center"
      alignItems="center"
    >
      <Typography
        sx={{
          fontSize: "3.2rem",
          fontWeight: "600"
        }}
        data-testid="notfoundheader"
      >
        {t("Not Found Header")}
      </Typography>
      <Typography
        sx={{
          fontSize: "1.8rem",
          fontWeight: "500",
          lineHeight: "3rem"
        }}
        data-testid="notfoundmessage"
      >
        {t("Not Found Message")}
      </Typography>
        <ColletteButton
          component="a"
          href="/"
          color="secondary"
          label={t("Return to homepage")}
          sx={{
            width: "26.4rem",
            textTransform: "unset"
          }}
          testId="homeButton"
        />
    </Stack>
  );
};
export default NotFound;
